import { render, staticRenderFns } from "./detailInfo.vue?vue&type=template&id=9d40ac70&scoped=true"
import script from "./detailInfo.vue?vue&type=script&lang=js"
export * from "./detailInfo.vue?vue&type=script&lang=js"
import style0 from "./detailInfo.vue?vue&type=style&index=0&id=9d40ac70&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d40ac70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d40ac70')) {
      api.createRecord('9d40ac70', component.options)
    } else {
      api.reload('9d40ac70', component.options)
    }
    module.hot.accept("./detailInfo.vue?vue&type=template&id=9d40ac70&scoped=true", function () {
      api.rerender('9d40ac70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/customerManage/detailInfo.vue"
export default component.exports